export class AutoPause {
    private observers: ObserverGeneral[] = [];

    // the time to be reached in order to make the auto feature stop tracking
    private timeToApply = 4;

    private static instance: AutoPause;

    private constructor() { }

    public static getInstance(): AutoPause {
        if (!AutoPause.instance) {
            AutoPause.instance = new AutoPause();
        }

        return AutoPause.instance;
    }

    private lastAction: Date;
    private enabled: boolean = false;
    private running: boolean = false;

    public run() {
        //autopause - run
        this.enabled = true;
        this.lastAction = new Date();
        this.startInterval();
    }

    private startInterval() {
        let interval = setInterval(() => {
            this.running = true;
            if (this.diffGetTime(this.lastAction, new Date()) >= this.timeToApply) {
                if (this.enabled) {
                    this.running = false;
                    this.notify();
                    clearInterval(interval);
                }
            }

            if (!this.enabled) {
                clearInterval(interval);
            }

        }, 100);
    }

    private diffGetTime(d1: Date, d2: Date) {
        console.log('difference: ' + Math.round((d2.getTime() - d1.getTime()) / 1000));
        return Math.round((d2.getTime() - d1.getTime()) / 1000);
    }

    public setEnabled(e: boolean) {
        this.enabled = e;
    }

    public setLastAction(la: Date) {
        this.lastAction = la;
    }

    public setRunning(r: boolean) {
        this.running = r;
    }

    public isRunning(): boolean {
        return this.enabled ? this.running : true;
    }

    public attach(observer: ObserverGeneral): void {
        const isExist = this.observers.includes(observer);
        if (isExist) {
            return console.log('Subject: Observer has been attached already.');
        }

        console.log('Subject: Attached an observer.');
        this.observers.push(observer);
    }

    public detach(observer: ObserverGeneral): void {
        const observerIndex = this.observers.indexOf(observer);
        if (observerIndex === -1) {
            return console.log('Subject: Nonexistent observer.');
        }

        this.observers.splice(observerIndex, 1);
        console.log('Subject: Detached an observer.');
    }

    public notify(): void {
        console.log('Subject: Notifying observers...');
        for (const observer of this.observers) {
            observer.update(this);
        }
    }
}

export interface ObserverGeneral {
    // Получить обновление от субъекта.
    update(subject: SubjectGeneral): void;
}

export interface SubjectGeneral {
    // Присоединяет наблюдателя к издателю.
    attach(observer: ObserverGeneral): void;

    // Отсоединяет наблюдателя от издателя.
    detach(observer: ObserverGeneral): void;

    // Уведомляет всех наблюдателей о событии.
    notify(): void;
}